var _linearGradient, _path, _linearGradient2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDjango(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o6Fl--qWZ-2FO5KaINR1fa_qc3TyHJPxEoH_gr1",
    x1: 30,
    x2: 30,
    y1: 62,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c822ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a6dff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o6Fl--qWZ-2FO5KaINR1fa_qc3TyHJPxEoH_gr1)",
    d: "M42.671,62c-0.155,0-0.311-0.036-0.452-0.108l-8.27-4.188 c-0.345-0.175-0.559-0.534-0.548-0.921c0.012-0.387,0.245-0.733,0.601-0.888c5.288-2.307,8.201-6.081,8.201-10.627V19.404 c0-0.265,0.105-0.52,0.293-0.708c0.188-0.187,0.442-0.292,0.707-0.292c0,0,0,0,0.001,0l8.802,0.004c0.552,0,0.999,0.448,0.999,1 v25.86c0,3.104-0.722,13.483-10.009,16.677C42.891,61.982,42.78,62,42.671,62z M36.642,56.826l6.096,3.086 c7.663-2.925,8.268-11.92,8.268-14.644V20.408l-6.802-0.003v24.864C44.203,50.086,41.536,54.133,36.642,56.826z M24.829,49.004 c-11.5,0-17.834-5.823-17.834-16.397c0-10.17,6.15-16.241,16.452-16.241c0.701,0,2.126,0.028,3.353,0.225V4c0-0.552,0.447-1,1-1 h8.802c0.553,0,1,0.448,1,1v42.875c0,0.445-0.294,0.837-0.722,0.96C33.57,48.794,27.059,49.004,24.829,49.004z M23.447,18.366 c-4.346,0-14.452,1.388-14.452,14.241c0,11.899,8.61,14.397,15.834,14.397c2.748,0,7.839-0.25,10.772-0.906V5H28.8v12.868 c0,0.333-0.166,0.644-0.442,0.83c-0.275,0.187-0.627,0.222-0.935,0.097C26.696,18.498,24.902,18.366,23.447,18.366z M25.738,40.674 c-5.121,0-7.941-2.865-7.941-8.067c0-5.065,2.672-7.634,7.941-7.634c0.646,0,1.382,0.08,2.249,0.245 c0.472,0.09,0.812,0.502,0.812,0.982v13.245c0,0.48-0.342,0.893-0.813,0.982C27.113,40.593,26.378,40.674,25.738,40.674z M25.738,26.973c-4.164,0-5.941,1.685-5.941,5.634c0,4.083,1.943,6.067,5.941,6.067c0.313,0,0.665-0.026,1.062-0.078V27.05 C26.406,26.999,26.055,26.973,25.738,26.973z M52.005,13.802h-8.802c-0.553,0-1-0.448-1-1V4c0-0.552,0.447-1,1-1h8.802 c0.553,0,1,0.448,1,1v8.802C53.005,13.354,52.558,13.802,52.005,13.802z M44.203,11.802h6.802V5h-6.802V11.802z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o6Fl--qWZ-2FO5KaINR1fb_qc3TyHJPxEoH_gr2",
    x1: 30,
    x2: 30,
    y1: 57.71,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6abff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6dc7ff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o6Fl--qWZ-2FO5KaINR1fb_qc3TyHJPxEoH_gr2)",
    d: "M46.2,7v2.8H49V7H46.2z M30.8,7v10.87l0.01,3.63c0,0-2.81-1.13-7.36-1.13 C18.8,20.37,11,21.96,11,32.61C11,35.67,11,45,24.83,45c2.35,0,6.07-0.18,8.77-0.57V7H30.8z M30.8,41.93 c-2.364,0.446-3.631,0.74-5.06,0.74c-6.23,0-9.94-3.76-9.94-10.06c0-6.22,3.53-9.64,9.94-9.64c0.77,0,1.63,0.09,2.62,0.28l2.44,0.47 V41.93z M46.2,22.41v22.86c0,4.42-1.99,8.35-5.62,11.31l2.22,1.13c5.74-2.8,6.2-10.15,6.2-12.44V22.41H46.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjango);
export default __webpack_public_path__ + "static/media/django.ffc5c65331715852dddd697fe744e856.svg";
export { ForwardRef as ReactComponent };